import { configureStore } from "@reduxjs/toolkit";
import opportunityReducer from "./Opportunity";
import projectReducer from "./ProjectOld";
import projectsReducer from "./Projects";
import authReducer from "./Auth";
import accountReducer from "./Account";
import toastReducer from "./Toast";
import notificationReducer from "./Notification";
import developerApplicationReducer from "./DeveloperApplication";
import workspace from "./Workspace";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const store = configureStore({
  reducer: {
    project: projectReducer,
    auth: authReducer,
    account: accountReducer,
    notification: notificationReducer,
    opportunity: opportunityReducer,
    projects: projectsReducer,
    toast: toastReducer,
    developerApplication: developerApplicationReducer,
    workspace,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const authSelector = (state: RootState) => state.auth;
export const workspaceSelector = (state: RootState) => state.workspace;
export const accountSelector = (state: RootState) => state.account;
export const notificationSelector = (state: RootState) => state.notification;
export const projectSelector = (state: RootState) => state.project;
export const projectsSelector = (state: RootState) => state.projects;
export const opportunitySelector = (state: RootState) => state.opportunity;
export const toastSelector = (state: RootState) => state.toast;
export const developerApplicationSelector = (state: RootState) =>
  state.developerApplication;
